import { __awaiter, __generator } from "tslib";
import { CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator, } from '@opentelemetry/core';
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from '@opentelemetry/resources';
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION, } from '@opentelemetry/semantic-conventions';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { WebVitalsInstrumentation } from './client-utils/web-vitals-instrumentation';
import { ClientErrorInstrumentation } from './client-utils/client-error-instrumentation';
import webAutoInstrumentations from './client-utils/web-auto-instrumentations';
require('zone.js');
var OtelClientTracer = function (_a) {
    var appName = _a.appName, appVersion = _a.appVersion, routes = _a.routes, config = _a.config;
    return __awaiter(void 0, void 0, void 0, function () {
        var enabledInstrumentations, provider, contextManager, instrumentations;
        var _b;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            if (typeof window === 'undefined')
                return [2 /*return*/];
            enabledInstrumentations = typeof config === 'boolean'
                ? {
                    fetch: false,
                    userInteraction: false,
                    documentLoad: false,
                    cwv: false,
                    error: config,
                }
                : {
                    fetch: (_c = config.fetch) !== null && _c !== void 0 ? _c : false,
                    userInteraction: (_d = config.userInteraction) !== null && _d !== void 0 ? _d : false,
                    documentLoad: (_e = config.documentLoad) !== null && _e !== void 0 ? _e : false,
                    cwv: (_f = config.cwv) !== null && _f !== void 0 ? _f : false,
                    error: (_g = config.error) !== null && _g !== void 0 ? _g : true,
                };
            provider = new WebTracerProvider({
                resource: new Resource((_b = {},
                    _b[SEMRESATTRS_SERVICE_NAME] = process.env['OTEL_BROWSER_SERVICE_NAME'] || appName,
                    _b[SEMRESATTRS_SERVICE_VERSION] = appVersion,
                    _b)),
            });
            provider.addSpanProcessor(new BatchSpanProcessor(new OTLPTraceExporter({
                url: process.env['OTEL_BROWSER_EXPORTER_OTLP_HTTP_ENDPOINT'],
                headers: {
                    Authorization: decodeURIComponent(process.env['OTEL_BROWSER_EXPORTER_OTLP_AUTHORIZATION_HEADER'] || ''),
                },
            })));
            contextManager = new ZoneContextManager();
            provider.register({
                contextManager: contextManager,
                propagator: new CompositePropagator({
                    propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
                }),
            });
            instrumentations = [];
            if (enabledInstrumentations.fetch ||
                enabledInstrumentations.userInteraction ||
                enabledInstrumentations.documentLoad) {
                instrumentations.push(webAutoInstrumentations({
                    fetch: enabledInstrumentations.fetch,
                    userInteraction: enabledInstrumentations.userInteraction,
                    documentLoad: enabledInstrumentations.documentLoad,
                }, routes));
            }
            if (enabledInstrumentations.cwv) {
                instrumentations.push(new WebVitalsInstrumentation(routes, appVersion));
            }
            if (enabledInstrumentations.error) {
                instrumentations.push(new ClientErrorInstrumentation(routes, appVersion));
            }
            if (instrumentations.length === 0)
                return [2 /*return*/];
            registerInstrumentations({
                tracerProvider: provider,
                instrumentations: instrumentations,
            });
            return [2 /*return*/];
        });
    });
};
export default OtelClientTracer;
//# sourceMappingURL=get-client-side-instrumentation.js.map